export const ROTA_BASE: string = "/";
export const ROTA_PADRAO: string = "/login";
export const ROTA_VINCULOS: string = "/vinculos";
export const ROTA_OPTIN: string = "/optin";
export const ROTA_ALTERAR_SENHA: string = "/change-password";
export const ROTA_SENHA_EXPIRADA: string = "/senha-expirada";
export const ROTA_WELCOME_ONBOARD_TOUR: string = "/welcome";
export const ROTA_AVISO_ATRASO: string = "/nonpayment";
export const ROTA_NOT_PAY: string = "/inadimplencia";
export const ROTA_AVISO_DESCREDENCIAMENTO_PRESTADOR: string = "/aviso-provedor-descredenciado"; //"/descredenciamento";
export const ROTA_AVISO_RECIBOS_REEMBOLSO: string = "/aviso-entrega-recibos-reembolso";
export const ROTA_OUVIDORIA: string = "/ouvidoria/criar";
export const ROTA_CHANGE_PASSWORD: string = "/change-password";

export const OPERACAO_OMINT: number = 1;
export const OPERACAO_KIPP: number = 4;

export const PERFIL_ASSOCIADO_OMINT: number = 1;
export const PERFIL_ASSOCIADO_SKILL: number = 1;
export const PERFIL_ASSOCIADO_KIPP: number = 25;

export function getRouteByPerfilNumber(operacao: number, perfil: number) {
  switch (operacao) {
    case OPERACAO_OMINT:
    case OPERACAO_KIPP:
      if (isAssociado(perfil)) {
        return ROTA_BASE;
      }
  }
  return ROTA_PADRAO;
}

export function isAssociado(perfil: number) {
  return perfil === PERFIL_ASSOCIADO_OMINT || perfil === PERFIL_ASSOCIADO_KIPP;
}

export const ROTAS_TRAVADAS = (
  state: any
): {
  condiction: boolean;
  path: string;
  nextPath?: boolean;
}[] => [
  {
    condiction: state.accessManagement?.notPay,
    path: ROTA_NOT_PAY
  },
  {
    condiction: state.myAccount?.terms?.length,
    path: ROTA_OPTIN,
    nextPath: true
  },
  {
    condiction: state.accessManagement?.nonpaymentWarning?.key,
    path: ROTA_AVISO_ATRASO
  },
  {
    condiction: state.myAccount?.changePasswordRequired,
    path: ROTA_SENHA_EXPIRADA
  },
  {
    condiction: state.refund?.showReceiptDeliveryNoticeOnInit,
    path: ROTA_AVISO_RECIBOS_REEMBOLSO
  },
  {
    condiction: !!(state.affiliate?.prestadoresSendoDescredenciados ?? []).find(p => !p.listado),
    path: ROTA_AVISO_DESCREDENCIAMENTO_PRESTADOR
  }
];
